import DirectSellerOnboarding from './DirectSellers/onBoarding';
export default function Content () {
    return (
        <DirectSellerOnboarding />
    );
}
